<ng-template #content>

  <div *ngIf="type === 'edit'">
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
              (click)="modalRef.dismiss('Cross click')" />
          </div>
        </div>
        <div class="row titleRow">
          <div class="col-12">
            <span class="title" i18n="modal_damage|@@damage">Dommage</span>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@damageType">Type de dégat : </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectDamage" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectDamage" [virtualScroll]='true' (change)="handlerChangeCost()"
                notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@location">Emplacement : </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectLocation" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectLocation" [virtualScroll]='true' (change)="handlerChangeCost()"
                notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt">
              <p i18n="modal_damage|@@sizeRange">Taille : </p>
            </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectDamageSize" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectDamageSize" [virtualScroll]='true' notFoundText="---" [clearable]='false'
                placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@severity">Sévérité : </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectSeverity" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectSeverity" [virtualScroll]='true' (change)="handlerChangeCost()"
                notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>

        <!-- externalImages here -->
        <div class="row">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@addpicture">Photo : </div>
          </div>
          <div class="col-9">
            <div class="line">

              <div class="custom-dropzone detection-dropzone" ngx-dropzone [accept]="'image/*'"
                (change)="onSelect($event)">
                <ngx-dropzone-label class="dropzone-label">

                  <div class="row p-0 m-0 justify-content-md-center">
                    <div class="col-9 col-md-6 buttonSend">
                      <div class="row justify-content-md-center">
                        <div class="col-3">
                          <img src="../../../assets/icon/upload-file.svg" alt="">
                        </div>
                        <div class="col-9 center">
                          <p class="h5 font-weight-bold" i18n="modal_damage|@@downloadPicture">Télécharger une image</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row  p-0 m-0 justify-content-md-center">
                    <div class="col-12 col-md-6">
                      <p class="smallText dark" i18n="modal_damage|@@or_drag_picture">ou déposer un fichier.</p>
                    </div>
                  </div>


                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs=" ngx-dropzone-preview" class="fileContainer"
                  *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                </ngx-dropzone-image-preview>
              </div>

            </div>
          </div>
        </div>

        <div class="row" *ngIf="getCUrrentFileLength() > 0">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@picturegallery">Galerie photo : </div>
          </div>
          <div class="col-9">
            <div class="line">

              <div class="galleryContainer">
                <div *ngFor="let file of currentFiles">
                  <div *ngIf="file.isDeleted === false">

                    <div class="div" class="galleryObject">

                      <img [src]='file.src' crossorigin="anonymous" alt="" class="galleryImage">
                      <ngx-dropzone-remove-badge class="ng-star-inserted galleryDelete" (click)='file.isDeleted = true'>
                        <svg>
                          <line x1="0" x2="10" y1="0" y2="10"></line>
                          <line x1="0" x2="10" y1="10" y2="0"></line>
                        </svg>
                      </ngx-dropzone-remove-badge>


                    </div>
                  </div>
                </div>


              </div>

            </div>
          </div>
        </div>
        <div class="row mt-3" *ngIf="(companyname === 'gefco' || isSuperAdmin) && isAuto">
          <div class="form-group">
            <div class="checkbox">
              <label class="checkbox-container">
                <input type="checkbox" [checked]="seenByInspector" (click)='handleDamageInspectorCheckbox()'>
                <span class="checkmark"></span></label>
              <span i18n="modal_damage|@@dinspected_damage">
                Dommage vu par l'inspecteur.
              </span>
            </div>
          </div>
        </div>

        <div class="row titleRow">
          <div class="col-9">
            <div class="title" i18n="modal_damage|@@cost">Chiffrage</div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@costType">Type de chiffrage :</div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [searchable]='false' placeholder='Précisez...' i18n-placeholder="editModal|@@Specify"
                [items]="possibleValuesSelectCost" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectCost" [virtualScroll]='true' (change)="handlerChangeCost()"
                [clearable]='false'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="newValueSelectCost !== undefined">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@costValue">FRE :</div>
          </div>
          <div class="col-9">
            <form>
              <div class="line">
                <div class="input-group ">
                  <input type="number" min="0" placeholder="200" [formControl]="costValue">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2" i18n="modal_damage|@@euro">€</span>
                  </div>
                </div>
                <span class="error" *ngIf="errorEmpty" i18n="modal_damage|@@errorEmptyInput">Erreur champ vide.</span>
              </div>
            </form>
          </div>
        </div>

        <div class="row titleRow" *ngIf="isSuperAdmin  ">
          <div class="col-9">
            <div class="title large" i18n="modal_damage|@@activeLearning">Active Learning</div>
          </div>
          <div class="col-3">
            <div class="parameters-toggle">
        <app-generic-toggle  (sendData)="showAL = $event; saveData()" [value]="showAL" ></app-generic-toggle>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="showAL && isSuperAdmin">
          <div class="col-12">
            <div class="form-group">
              <div class="row">
                <div class="col-12" *ngFor="let ALOption of ALValues">
                  <div class="checkbox">
                    <input type="checkbox" name="addRoiIsAuto" id="addRoiIsAuto"
                      [checked]="ALselected.includes(ALOption.key)" (click)="clickALselector(ALOption.key)">
                    {{ALOption.value}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-lg danger" i18n="modal_damage|@@removeDamage"
        (click)="changeto('delete')">Supprimer ce dommage</button>
      <button type="button" class="btn btn-lg primary" i18n="modal_damage|@@cancel"
        (click)="modalRef.dismiss('Cross click')">Annuler</button>
      <button type="button" class="btn btn-lg primary" i18n="modal_damage|@@validateDamage"
        (click)="saveModal()">Valider</button>
    </div>
  </div>

  <div *ngIf="type === 'delete' && isAuto === true">
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
              (click)="modalRef.dismiss('Cross click')" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span class="title" i18n="modal_damage|@@removal">Suppression</span>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <div class="linetxt" i18n="modal_damage|@@reason">Motif : </div>
          </div>
          <div class="col-10">
            <div class="line">
              <ng-select [searchable]='false' placeholder='Précisez...' i18n-placeholder="editModal|@@Specify"
                [items]="possibleValuesSelectDelete" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectDelete" [virtualScroll]='true' (change)="onChange($event, 'type')"
                [clearable]='false'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="notDamage">
          <div class="col-2">
            <div class="linetxt" i18n="modal_damage|@@becauseOf">Cause : </div>
          </div>
          <div class="col-10">
            <div class="line">
              <ng-select [searchable]='false' placeholder='Précisez...' i18n-placeholder="editModal|@@Specify"
                [items]="possibleValuesSelectDeleteNotDamage" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectDeleteNotDamage" [virtualScroll]='true' (change)="onChange($event, 'option')"
                [clearable]='false'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="text">
          <div class="col-2">
            <div class="linetxt" i18n="modal_damage|@@auther">Autre : </div>
          </div>
          <div class="col-10">
            <div class="line">
              <form><input type="text" i18n-placeholder="modal_damage|@@Comment" placeholder="Commentaire..."
                  [formControl]="other"></form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-lg primary" (click)="modalRef.dismiss('Cross click')">Annuler</button>
      <button *ngIf="showSubmit && ((newValueSelectDelete !== 'other' && !notDamage )
        || (newValueSelectDelete === 'other'  && other.value.length > 0)
        || (newValueSelectDeleteNotDamage && newValueSelectDeleteNotDamage.length > 0) )" type="button"
        class="btn btn-lg primary" (click)="modalRef.close('Save click')"
        i18n="modal_damage|@@remove">Supprimer</button>
    </div>
  </div>

  <div *ngIf="type === 'delete' && isAuto !== true">
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
              (click)="modalRef.dismiss('Cross click')" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span class="title" i18n="modal_damage|@@removal">Suppression</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span i18n="modal_damage|@@deletingConfirmation">Confirmez vous la suppression de ce dommage ?</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-lg primary" i18n="modal_damage|@@cancel"
        (click)="modalRef.dismiss('Cross click')">Annuler</button>
      <button type="button" class="btn btn-lg primary" i18n="modal_damage|@@deleteDamage"
        (click)="modalRef.close('Save click')">Supprimer</button>
    </div>
  </div>

  <div *ngIf="type === 'create'">
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
              (click)="modalRef.dismiss('Cross click')" />
          </div>
        </div>
        <div class="row titleRow">
          <div class="col-12">
            <span class="title">
              <p i18n="modal_damage|@@damage">Dommage</p>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt">
              <p i18n="modal_damage|@@damageType">Type de dégat : </p>
            </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectDamage" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectDamage" [virtualScroll]='true' (change)="handlerChangeCost()"
                notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt">
              <p i18n="modal_damage|@@location">Emplacement : </p>
            </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectLocation" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectLocation" [virtualScroll]='true' (change)="handlerChangeCost()"
                notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt">
              <p i18n="modal_damage|@@sizeRange">Taille : </p>
            </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectDamageSize" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectDamageSize" [virtualScroll]='true' notFoundText="---" [clearable]='false'
                placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt">
              <p i18n="modal_damage|@@severity">Sévérité : </p>
            </div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [items]="possibleValuesSelectSeverity" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectSeverity" [virtualScroll]='true' (change)="handlerChangeCost()"
                notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@picture">Photo : </div>
          </div>
          <div class="col-9">
            <div class="line">

              <div class="custom-dropzone detection-dropzone" ngx-dropzone [accept]="'image/*'"
                (change)="onSelect($event)">


                <ngx-dropzone-label class="dropzone-label">

                  <div class="row p-0 m-0 justify-content-md-center">
                    <div class="col-9 col-md-6 buttonSend">
                      <div class="row justify-content-md-center">
                        <div class="col-3">
                          <img src="../../../assets/icon/upload-file.svg" alt="">
                        </div>
                        <div class="col-9 center">
                          <p class="h5 font-weight-bold" i18n="modal_damage|@@downloadPicture">Télécharger une image</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row  p-0 m-0 justify-content-md-center">
                    <div class="col-12 col-md-6">
                      <p class="smallText dark" i18n="modal_damage|@@dragPicture">ou déposer un fichier.</p>
                    </div>
                  </div>

                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs=" ngx-dropzone-preview" class="fileContainer"
                  *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                  <!-- <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label> -->
                </ngx-dropzone-image-preview>
              </div>



            </div>
          </div>
        </div>
        <div class="row titleRow">
          <div class="col-9">
            <div class="title">
              <p i18n="modal_damage|@@cost">Chiffrage</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@costType">Type de chiffrage :</div>
          </div>
          <div class="col-9">
            <div class="line">
              <ng-select [searchable]='false' placeholder='Précisez...' i18n-placeholder="editModal|@@Specify"
                [items]="possibleValuesSelectCost" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="newValueSelectCost" [virtualScroll]='true' (change)="handlerChangeCost()"
                [clearable]='false'>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="newValueSelectCost !== undefined">
          <div class="col-3">
            <div class="linetxt" i18n="modal_damage|@@costValue">FRE :</div>
          </div>
          <div class="col-9">
            <form>
              <div class="line">
                <div class="input-group">
                  <input type="number" min="0" placeholder="200" [formControl]="costValue">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2" i18n="modal_damage|@@euro">€</span>
                  </div>
                </div>
                <span i18n="modal_damage|@@errorEmptyInput" class="error" *ngIf="errorEmpty">Erreur champ vide.</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="isSuperAdmin">
      <div class="row">
        <div class="col-12">
          <div class="checkbox">
            <input type="checkbox" name="addRoiIsAuto" id="addRoiIsAuto" [(ngModel)]="isROIAuto"
              [attr.disabled]="roi?.get && roi?.get('isAuto') && !roi?.get('isValidated')?'' : null">
            Simuler ROI automatique
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-lg primary" i18n="modal_damage|@@cancel"
        (click)="modalRef.dismiss('Cross click')">Annuler</button>
      <button type="button" class="btn btn-lg primary" i18n="modal_damage|@@validate"
        (click)="saveModal()">Valider</button>
    </div>
  </div>

</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/roi-edit-modal-v2/roi-edit-modal-v2.component.html